import { Modal, notification, Spin } from "antd";
import requestService from "api/request";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "store";
import { onSetUser } from "store/app";

const AccountSetting = () => {
  const { t } = useTranslation();
  const { user } = useAppSelector((state) => state.app) as any;
  const [loading, setLoading] = useState(false);
    const dispatch = useAppDispatch()
  const [form, setForm] = useState<any>();

  const [openPasswordWithdraw, setOpenPasswordWithdraw] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);

  const handResetPassword = async () => {
    setLoading(true);
    setOpenPassword(false);
    try {
      const res = await requestService.post("/profile/reset-password", {
        data: {
          ...form,
        },
      });
      if (res && res.data) {
        notification.success({
          message: "Updated!!",
          duration: 5,
        });
      }
    } catch (error: any) {
      console.log(error);
      notification.error({
        message: error?.response?.data?.message,
        duration: 5,
      });
    }
    setLoading(false);
    setForm({
        oldPass:"",
        newPass:""
    });
  };

  const handlePasswordWithdraw = async () => {
    setLoading(true);
    setOpenPasswordWithdraw(false);
    try {
      if (user?.withdrawPassWord) {
        const res = await requestService.post(
          "/profile/resetWithdrawPassword",
          {
            data: {
              ...form,
            },
          }
        );
        if (res && res.data) {
          notification.success({
            message: "Updated!!",
            duration: 5,
          });
        }
      } else {
        const res = await requestService.post("/profile/update", {
          data: {
            withdrawPassWord: form?.newPass,
          },
        });
        if (res && res.data) {
          notification.success({
            message: "Updated!!",
            duration: 5,
          });
          dispatch(onSetUser(res?.data?.data))
        }
      }
    } catch (error: any) {
      console.log(error);
      notification.error({
        message: error?.response?.data?.message,
        duration: 5,
      });
    }
    setLoading(false);
    setForm({
        oldPass:"",
        newPass:""
    });
  };
  return (
    <div
      data-v-5ea43a59=""
      className="personal-main-box max-w-[1208px] mx-auto px-5"
    >
      <Spin spinning={loading} fullscreen />

      <Modal
        footer={null}
        open={openPasswordWithdraw}
        onCancel={() => setOpenPasswordWithdraw(false)}
        centered
      >
        {user?.withdrawPassWord && (
          <div className="phone:pl-0">
            <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
              <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
                <input
                  type="text"
                  autoComplete="off"
                  placeholder={t("Nhập mật khẩu cũ")}
                  className="bit-input__inner"
                  style={{ height: 38 }}
                  value={form?.oldPass}
                  onChange={(e) =>
                    setForm({ ...form, oldPass: e.target.value })
                  }
                />
              </div>
            </div>{" "}
          </div>
        )}

        <div className="phone:pl-0">
          <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
            <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
              <input
                type="text"
                autoComplete="off"
                placeholder={t("Nhập mật khẩu mới")}
                className="bit-input__inner"
                style={{ height: 38 }}
                value={form?.newPass}
                onChange={(e) => setForm({ ...form, newPass: e.target.value })}
              />
            </div>
          </div>{" "}
        </div>
        <div className="flex justify-between items-center mt-40px phone:mt-32px w-full">
          <div className="flex items-center w-1/3 mx-auto">
            <button
              type="button"
              className="operate-btn"
              data-v-489927de=""
              data-testid="LoginNowButton"
              onClick={handlePasswordWithdraw}
            >
              <span>{t("Xác nhận")}</span>
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        footer={null}
        open={openPassword}
        onCancel={() => setOpenPassword(false)}
        centered
      >
        <div className=" phone:pl-0">
          <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
            <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
              <input
                type="text"
                autoComplete="off"
                placeholder={t("Nhập mật khẩu cũ")}
                className="bit-input__inner"
                style={{ height: 38 }}
                value={form?.oldPass}
                onChange={(e) => setForm({ ...form, oldPass: e.target.value })}
              />
            </div>
          </div>{" "}
        </div>
        <div className=" phone:pl-0">
          <div className="bit-select mt-20px w-full box-border phone:mt-8px bit-select--large">
            <div className="bit-input bit-input--large bit-input--round  bit-input--suffix">
              <input
                type="text"
                autoComplete="off"
                placeholder={t("Nhập mật khẩu mới")}
                className="bit-input__inner"
                style={{ height: 38 }}
                value={form?.newPass}
                onChange={(e) => setForm({ ...form, newPass: e.target.value })}
              />
            </div>
          </div>{" "}
        </div>
        <div className="flex justify-between items-center mt-40px phone:mt-32px w-full">
          <div className="flex items-center w-1/3 mx-auto">
            <button
              type="button"
              className="operate-btn"
              data-v-489927de=""
              data-testid="LoginNowButton"
              onClick={handResetPassword}
            >
              <span>{t("Xác nhận")}</span>
            </button>
          </div>
        </div>
      </Modal>
      <div data-v-5ea43a59="" className="personal-main-content">
        <div
          data-v-47f68dcf=""
          data-v-5ea43a59=""
          className="security-wrapper flex flex-col black"
        >
          <div
            data-v-582ce0f9=""
            data-v-47f68dcf=""
            className="security_1 mt-24px flex flex-col py-8px mb-64px justify-between md:flex-row md:mt-16px md:h-82px md:py-8px lg:!mr-150px"
          >
            <div data-v-582ce0f9="" className="flex flex-col">
              <div
                data-v-582ce0f9=""
                className="title font-700 text-fs32 text-v3PrimaryText mb-8px h-38px leading-38.4px"
              >
                {t("Bảo mật")}
              </div>
            </div>{" "}
          </div>{" "}
          <div data-v-47f68dcf="" className="cards">
            <div
              data-v-47f68dcf=""
              className="c-container flex flex-col flex-wrap w-full gap-16px md:flex-row"
            >
              <div
                data-v-eee47c9e=""
                data-v-47f68dcf=""
                className="card  border border-[#27282B] p-5 rounded-md"
              >
                <div data-v-eee47c9e="" className="card-panel relative">
                  <div
                    data-v-eee47c9e=""
                    className="flex flex-row justify-between mb-20px"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      className="size-6 text-[#fff]"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                  </div>{" "}
                  <div
                    data-v-eee47c9e=""
                    className="text-fs16 font-500 text-v3PrimaryText mb-4px leading-22px"
                  >
                    {t("Cài đặt mật khẩu rút tiền")}
                  </div>{" "}
                  {/* <p
                    data-v-eee47c9e=""
                    className="text-fs12 font-400 text-v3TertiaryText leading-16.8px "
                  >
                    Quản lý các thiết bị được phép truy cập vào tài khoản của
                    bạn.
                  </p>{" "} */}
                  <div
                    data-v-eee47c9e=""
                    className="mt-20px flex flex-row justify-start items-center"
                  >
                    <div
                      data-v-eee47c9e=""
                      className="operate-btn"
                      onClick={() => setOpenPasswordWithdraw(true)}
                    >
                      {!user?.withdrawPassWord
                        ? t("Bật")
                        : t("Thay đổi mật khẩu rút tiền")}
                    </div>
                  </div>
                </div>
              </div>{" "}
              <div
                data-v-849c6a42=""
                data-v-47f68dcf=""
                className="card border border-[#27282B] p-5 rounded-md "
              >
                <div data-v-849c6a42="" className="card-panel relative">
                  <div
                    data-v-849c6a42=""
                    className="flex flex-row justify-between mb-20px"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      className="size-6 text-[#fff]"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
                      />
                    </svg>
                  </div>{" "}
                  <div
                    data-v-849c6a42=""
                    className="text-fs16 font-500 text-v3PrimaryText mb-4px leading-22px"
                  >
                    {t("Thay đổi mật khẩu")}
                  </div>{" "}
                  <div
                    data-v-849c6a42=""
                    className="mt-20px flex flex-row  mt-20px justify-start items-center"
                  >
                    <div data-v-849c6a42="">
                      <div
                        data-v-849c6a42=""
                        className="operate-btn"
                        onClick={() => setOpenPassword(true)}
                      >
                        {t("Thay đổi")}
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>{" "}
              <div data-v-47f68dcf="" className="padding1" />
            </div>
          </div>{" "}
        </div>
      </div>
    </div>
  );
};

export default AccountSetting;
